/**
 * Deep merge two objects
 * @param {Object} target - The target object to merge into
 * @param {Object} source - The source object to merge from
 * @returns {Object} - The merged object
 */
const deepMergeObjects = (target, source) => {
  const result = { ...target };

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        // If the source value is an object (but not an array), recursively merge
        result[key] = deepMergeObjects(result[key] || {}, source[key]);
      } else {
        // Otherwise, directly assign the value
        result[key] = source[key];
      }
    }
  }

  return result;
};

export default deepMergeObjects; 